import { DocumentVersionsNamespace } from '@repo/sdk/models/components';

type UxdsVersionRollbackNamespaceConfig = {
  title: string;
  shortLabel: string;
  sdkNamespace: DocumentVersionsNamespace;
};

export const UXDS_VERSION_ROLLBACK_CONFIG = {
  process_view: {
    title: 'Process View',
    shortLabel: 'PV',
    sdkNamespace: DocumentVersionsNamespace.ProcessView,
  },
  facility_map: {
    title: 'Facility Map',
    shortLabel: 'FM',
    sdkNamespace: DocumentVersionsNamespace.FacilityMap,
  },
} as const satisfies Record<string, UxdsVersionRollbackNamespaceConfig>;

export type UxdsRollbackNamespace = keyof typeof UXDS_VERSION_ROLLBACK_CONFIG;

export const UXDS_VERSION_ROLLBACK_NAMESPACES = Object.keys(
  UXDS_VERSION_ROLLBACK_CONFIG
) as UxdsRollbackNamespace[];

export const UXDS_ROLLBACK_NAMESPACE_SET = new Set<string>(UXDS_VERSION_ROLLBACK_NAMESPACES);

/** Map SDK DocumentVersionsNamespace → rollback key; undefined if not registered */
export const toUxdsRollbackNamespace = (
  ns: DocumentVersionsNamespace
): UxdsRollbackNamespace | undefined =>
  UXDS_VERSION_ROLLBACK_NAMESPACES.find(
    (key) => UXDS_VERSION_ROLLBACK_CONFIG[key].sdkNamespace === ns
  );

/** Map rollback key → SDK DocumentVersionsNamespace for API calls */
export const toSdkNamespace = (ns: UxdsRollbackNamespace): DocumentVersionsNamespace =>
  UXDS_VERSION_ROLLBACK_CONFIG[ns].sdkNamespace;

/** Legacy localStorage field names → config keys */
export const LEGACY_VERSION_FIELDS = {
  processViewVersion: 'process_view',
  facilityMapVersion: 'facility_map',
} as const satisfies Record<string, UxdsRollbackNamespace>;

/** Map SDK DocumentVersionsNamespace → rollback key for plumbed features; throws if not registered */
export const requireUxdsRollbackNamespace = (
  ns: DocumentVersionsNamespace
): UxdsRollbackNamespace => {
  const key = toUxdsRollbackNamespace(ns);
  if (!key) {
    throw new Error(`Namespace "${ns}" is not registered for UXDS version rollback`);
  }
  return key;
};
